<template>
  <td
      v-if="header.value === 'id' &&header.visible"
      class="text-no-wrap"
      @click="$tools.isDefined(openLinksNewWindow) ? $tools.openUrl(`/user/${$router.currentRoute.params.type}/${item.id}/`, true) : $router.push({ path: `/user/${$router.currentRoute.params.type}/${item.id}/` })"
  >
    {{item.id}}
  </td>

  <td
      v-else-if="header.value === 'lastName'&&header.visible"
      class="text-no-wrap"
      @click="$tools.isDefined(openLinksNewWindow) ? $tools.openUrl(`/user/${$router.currentRoute.params.type}/${item.id}/`, true) : $router.push({ path: `/user/${$router.currentRoute.params.type}/${item.id}/` })"
  >
    <v-icon v-if="filter.hasDebt&&loadState.isSuccess" class="mr-2" color="red" small>mdi-alert-circle</v-icon>
    {{$tools.userFullName(item)}}
  </td>

  <td v-else-if="header.value === 'type'&&header.visible" class="text-no-wrap" >{{item.type==='client' ? 'Клиент' : item.type==='spec' ? 'Специалист' : 'Администратор'}}</td>

  <td v-else-if="header.value === 'userSpecs'&&header.visible" class="text-wrap">
    <v-sheet width="500" color="transparent">
      <div v-for="(userSpec,index) in item.userSpecs" :key="'userSpec'+index" class="caption">
        {{userSpec.spec.name}}
        <v-icon small>mdi-chevron-left</v-icon>
        {{userSpec.comDiv.comBranch.name}}
        <v-icon v-if="!$tools.isEmpty(userSpec.commentAdmin)" class="ml-2" size="12">mdi-comment-text-outline</v-icon>
        {{userSpec.commentAdmin}}

        <v-icon v-if="userSpec.isExternalSelfVisitCreate" class="ml-2" size="14" color="primary" title="Сторонние сервисы">mdi-remote-desktop</v-icon>
        <v-icon v-if="userSpec.isSelfVisitCreate" class="ml-2" size="14" color="primary" title="Сайт и моб. приложение">mdi-monitor-cellphone</v-icon>
        <v-divider v-if="item.userSpecs.length-1>index"/>
      </div>
    </v-sheet>
  </td>

  <td v-else-if="header.value === 'userProfile.gender'&&header.visible" class="text-no-wrap">
    {{item.userProfile?.gender==='male' ? 'Мужской' : 'Женский'}}
  </td>

  <td v-else-if="header.value === 'userProfile.birth'&&header.visible" class="text-no-wrap">
    {{$tools.date(item.userProfile?.birth)}}
  </td>

  <td v-else-if="header.value === 'userProfile.medCardNumber'&&header.visible" class="text-no-wrap">
    {{$tools.isEmpty(item.userProfile.medCardStore) ? '-' : item.userProfile.medCardStore }} /
    {{$tools.isEmpty(item.userProfile.medCardStorePosition) ? '-' : item.userProfile.medCardStorePosition }} /
    {{$tools.isEmpty(item.userProfile.medCardNumber) ? item.id : item.userProfile.medCardNumber}}
  </td>

  <td v-else-if="header.value === 'tagLinks'&&header.visible" class="text-no-wrap">
    <template v-for="v in item.tagLinks">
      <chip v-if="v.status==='active'" :key="'tag_'+v.id" class="mr-2" :color="v.tag.color"><span :style="`color:${$tools.getContrastColor(v.tag.color)}`">{{v.tag.name}}</span></chip>
    </template>
  </td>

  <td v-else-if="header.value === 'phone'&&header.visible" class="text-no-wrap">
    <call-phone :phone="item.phone"/>
  </td>

  <td v-else-if="header.value === 'userProfile.phone1'&&header.visible" class="text-no-wrap">
    <span v-if="$tools.isEmpty(item.userProfile.phone1)">-</span>
    <call-phone v-else :phone="item.userProfile.phone1"/>
  </td>

  <td v-else-if="header.value === 'userProfile.telegram'&&header.visible" class="text-no-wrap">
    <span v-if="$tools.isEmpty(item.userProfile.telegram)">-</span>
    <link-view v-else :url="'https://t.me/'+item.userProfile.telegram" :text="item.userProfile.telegram" newWindow/>
  </td>

  <td v-else-if="header.value === 'userProfile.email' && header.visible" class="text-no-wrap">
    <span v-if="$tools.isEmpty(item.userProfile.email)">-</span>
    <link-view v-else :url="'mailto:'+item.userProfile.email" :text="item.userProfile.email" newWindow/>
  </td>
</template>

<script>
import LinkView from "@/components/LinkView";
import CallPhone from "@/components/CallPhone.vue";
import Chip from "../../componentsV2/base/Chip.vue";
export default {
  components: {
    Chip,
    CallPhone,
    LinkView,
  },
  props:['header','item','filter','openLinksNewWindow']
}
</script>


